import React from 'react';
import { Form } from 'react-bootstrap';

const Input = ({ 
    type = 'text', 
    placeholder, 
    value, 
    onChange, 
    name, 
    label, 
    required = false, 
    disabled = false, 
    readOnly = false,
    size,
    as,
    rows,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    helpText,
    isValid,
    isInvalid,
    feedback,
    ...props 
}) => {
    return (
        <Form.Group className={className} style={style}>
            {label && <Form.Label>{label}</Form.Label>}
            <Form.Control 
                type={type} 
                placeholder={placeholder} 
                value={value} 
                onChange={onChange} 
                name={name}
                required={required}
                disabled={disabled}
                readOnly={readOnly}
                size={size}
                as={as}
                rows={rows}
                isValid={isValid}
                isInvalid={isInvalid}
                {...props}
            />
            {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
            {feedback && <Form.Control.Feedback type={isInvalid ? 'invalid' : 'valid'}>{feedback}</Form.Control.Feedback>}
        </Form.Group>
    );
};

export default Input;

